<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row">
        <div class="col-md-4">
          <fieldset style="height: 79vh">
            <legend class="text-black">
              {{ $t('studentScoringEntry.scoreEntry') }}
            </legend>
            <div
              class="ts-overflow-y-auto ts-overflow-x-hidden"
              style="max-height: 73vh"
              v-if="isNotIgnoreByScoringCycle"
            >
            <div
                class="form-group m-b-10"
                v-if="this.model.scoring_cycle_id == 5"
              >
                <label class="col-form-label control-label required">
                  {{ $t('studentScoringEntry.unitTitle') }}
                </label>
                <div>
                  <input
                    class="form-control"
                    v-model="unit_title"
                    :class="{
                      'is-invalid': errors.has('unit_title')
                    }"
                  />
                  <div class="invalid-feedback" v-if="errors.has('unit_title')">
                    {{ errors.first('unit_title') }}
                  </div>
                </div>
              </div>
              <table style="width: 100%">
                <thead class="ts-sticky ts-top-0 ts-bg-gray-100">
                  <tr>
                    <th class="ts-text-xs">
                      {{ $t('studentScoringEntry.componentSub') }}
                    </th>
                    <th class="ts-text-xs text-center">
                      {{ $t('studentScoringEntry.actualScore') }}
                    </th>
                    <th class="ts-text-xs text-center ts-w-32">
                      {{ $t('studentScoringEntry.maxScore') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(mainData, index) in dataInput">
                    <tr :key="index">
                      <td class="ts-text-sm text-left">
                        <span class="badge badge-primary">
                          <p>
                            {{ getComponentName(mainData.sc_subject_id) ? getComponentName(mainData.sc_subject_id).kh : '' }}
                          </p>
                          <p>
                            {{ getComponentName(mainData.sc_subject_id) ? getComponentName(mainData.sc_subject_id).en : '' }}
                          </p>
                        </span>
                      </td>
                      <td colspan="2" class="ts-text-xs text-right">
                        <span class="badge badge-info">{{
                          getActualScoreMainComponent(mainData.sc_subject_id)
                        }}</span>
                      </td>
                    </tr>
                    <tr
                      v-for="(sub, index) in mainData.sc_item_subject_comp_list"
                    >
                      <td class="text-right ts-text-xs">
                        {{
                          getSubcomponentName(
                            mainData.sc_subject_id,
                            sub.sc_item_subject_comp_id
                          )
                        }}
                      </td>
                      <td>
                        <div
                          v-if="
                            isAutoFromAttendance(
                              mainData.sc_subject_id,
                              sub.sc_item_subject_comp_id
                            )
                          "
                        >
                          <span style="display: none">{{
                            getScoreAutoFromAttendance(mainData.sc_subject_id,sub)
                          }}</span>
                        </div>
                        <div
                          v-if="
                            getIsHasComponentItems(
                              mainData.sc_subject_id,
                              sub.sc_item_subject_comp_id
                            )
                          "
                        >
                          <!-- v-if="sub.actual_score <= 0" -->
                          <span style="display: none">{{
                            getAvgScoreComponentItems(sub)
                          }}</span>
                        </div>
                        <div
                          v-if="isElectiveSubjectParent(mainData.sc_subject_id)"
                        >
                          <!-- v-if="sub.actual_score <= 0" -->
                          <span style="display: none">{{
                            getAvgScoreByParentSubject(
                              mainData.sc_subject_id,
                              sub
                            )
                          }}</span>
                        </div>
                        <input
                          type="number"
                          v-model.number="sub.actual_score"
                          class="text-right ts-w-40 form-control form-control-sm"
                          :disabled="
                            getIsHasComponentItems(
                              mainData.sc_subject_id,
                              sub.sc_item_subject_comp_id
                            ) || 
                            isElectiveSubjectParent(mainData.sc_subject_id) || 
                            isAutoFromAttendance(
                              mainData.sc_subject_id,
                              sub.sc_item_subject_comp_id
                            )
                          "
                          :max="sub.max_score"
                          :class="{
                            'is-invalid': errors.has(
                              'sc_item_subject_comp_list.' +
                                sub.sc_item_subject_comp_id +
                                '.actual_score'
                            )
                          }"
                        />
                      </td>
                      <td
                        class="ts-whitespace-no-wrap"
                        @dblclick="() => (sub.disable = false)"
                      >
                        <input
                          type="number"
                          v-model.number="sub.max_score"
                          class="text-right inline-block ts-w-16 form-control form-control-sm"
                          :disabled="sub.disable"
                        />
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
            <div
              v-if="!isNotIgnoreByScoringCycle"
              class="text-center ts-justify-items-center"
            >
              Ignore entry score for scoring cycle:
              <span class="ts-font-bold text-primary">
                {{
                  scoringCycleSelected
                    ? scoringCycleSelected.scoring_cycle_name
                    : '-'
                }}
              </span>
            </div>
          </fieldset>
        </div>
        <div class="col-md-8 ts-space-y-2 ts-border-l-4">
          <div class="row">
            <div class="col-md-9 ts-space-y-2">
              <student-info-entry
                v-model="model"
                :class-operations="classOperations"
                :student-profiles="studentProfiles"
              />
            </div>
            <div class="col-md-3">
              <div class="col-md-12">
                <div id="cover-image">
                  <img
                    :src="require('@/assets/background-student-profile.png')"
                    alt
                    class="cover"
                  />
                  <div id="img-frame" class="text-center mb-1">
                    <img
                      v-lazy="{
                        src: studentProfiles.photo,
                        error: require('@/assets/user_default.png'),
                        loading: require('@/assets/Rolling-1s-200px_2.svg')
                      }"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 text-center">
                    <span>{{
                      studentProfiles ? studentProfiles.card_number : '-'
                    }}</span>
                    <h3
                      class="text-center ts-font-bold ts-text-sm mb-0 text-uppercase text-primary"
                    >
                      {{ studentProfiles ? studentProfiles.full_name_en : '-' }}
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <fieldset style="height: 65vh">
              <!-- <div
                class="form-group m-b-10"
                v-if="this.model.scoring_cycle_id == 5"
              >
                <label class="col-form-label control-label required">
                  {{ $t('studentScoringEntry.unitTitle') }}
                </label>
                <div>
                  <input
                    class="form-control"
                    v-model="unit_title"
                    :class="{
                      'is-invalid': errors.has('unit_title')
                    }"
                  />
                  <div class="invalid-feedback" v-if="errors.has('unit_title')">
                    {{ errors.first('unit_title') }}
                  </div>
                </div>
              </div> -->
              <!-- <learning-strands-rating
                v-model="learning_strands_sc_subject_id_list"
                :model-data="model"
                :elective-subjects="electiveSubjects"
                :validate="errors"
                v-if="enableRating"
              /> -->
              <learning-expectation-rating
                v-model="learning_strands_sc_subject_id_list"
                :model-data="model"
                :learning-exepectation-subjects="learningExpectationSubjects"
                :validate="errors"
                v-if="enableRating"
              />
              <div
                v-if="!enableRating"
                class="text-center ts-justify-items-center"
              >
                No enable rating score entry for scoring cycle:
                <span class="ts-font-bold text-primary">
                  {{
                    scoringCycleSelected
                      ? scoringCycleSelected.scoring_cycle_name
                      : '-'
                  }}
                </span>
              </div>
            </fieldset>
          </div>
        </div>
        <a-modal
          v-if="advisor_comment"
          v-model="advisor_comment"
          :zIndex="1020"
          :title="'Student Name : ' + studentProfiles.full_name_en"
          :maskClosable="false"
          width="950px"
          :footer="null"
        >
          <advisor-comment
            v-model="model"
            @closeModal="() => (advisor_comment = false)"
          />
        </a-modal>
        <a-modal
          v-if="grading_definition"
          v-model="grading_definition"
          :zIndex="1020"
          :title="'Grading Definition'"
          :maskClosable="false"
          width="800px"
          :footer="null"
        >
          <grading-definition
            v-model="model"
            :grading-definitions="gradingDefinitions"
          />
        </a-modal>
      </div>
    </ts-loading-banner>
    <div class="ant-modal-footer ts-bottom-0 ts-left-0 ts-fixed ts-w-full">
      <ts-button
        color="info"
        @click.prevent="() => (grading_definition = true)"
        >{{ $t('studentScoringEntry.gradingDefinition') }}</ts-button
      >
      <ts-button color="warning" @click.prevent="onAdvisorComment()">{{
        $t('studentScoringEntry.comment')
      }}</ts-button>
      <ts-button @click.prevent="$emit('closeModal')">{{
        $t('cancel')
      }}</ts-button>
      <ts-button
        color="primary"
        @click.prevent="onSave"
        :waiting="waiting"
        :disabled="waiting"
        >{{ $t('save') }}</ts-button
      >
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
// import LearningStrandsRating from './learning-strands-rating'
import LearningExpectationRating from './learning-expectation-rating'
import StudentInfoEntry from './student-info-entry'
import GradingDefinition from './grading-definition.vue'
import AdvisorComment from './advisor-comment-with-entry.vue'
import { includes } from 'lodash'

export default {
  name: 'studentScoringEntryNumeric',
  components: {
    // LearningStrandsRating,
    StudentInfoEntry,
    GradingDefinition,
    AdvisorComment,
    LearningExpectationRating
  },
  props: [
    'value',
    'classOperations',
    'studentProfiles',
    'ignoreScoringOnCycle',
    'enableRatingOnCycle',
    'gradeId',
    'acpsId'
  ],
  data() {
    return {
      waiting: false,
      loading: false,
      show_alert: false,
      advisor_comment: false,
      grading_definition: false,
      errors: new Errors(),
      scoreComponents: [],
      electiveSubjects: [],
      gradingDefinitions: [],
      entry_on_student: [],
      model: {},
      dataInput: [],
      successCreate: [],
      actual_score_for_main_component_display: [], // for display max score on main component
      learning_strands_sc_subject_id_list: [], // for display max score on main component,
      unit_title: null,
      learning_expectation_sc_subject_id_list: [], // for display max score on main component,
      learningExpectationSubjects: []
    }
  },
  created() {
    this.model = this.value
    this.fetchData()
  },
  computed: {
    isNotIgnoreByScoringCycle() {
      return this.ignoreScoringOnCycle.length > 0
        ? !this.ignoreScoringOnCycle.includes(this.model.scoring_cycle_id)
        : true
    },
    enableRating() {
      return this.enableRatingOnCycle.length > 0
        ? this.enableRatingOnCycle.includes(this.model.scoring_cycle_id)
        : false
    },
    scoringCycleSelected() {
      return this.$store.state.studentScoringEntry.scoring_cycles.find(
        c => c.scoring_cycle_id == this.model.scoring_cycle_id
      )
    }
  },
  methods: {
    ...mapActions('studentScoringEntry', [
      'getProgramStructure',
      'getComponents',
      'findScoreAssementDetail',
      'store',
      'findScoring',
      'getAvgScore',
      'getAvgScoreBySubject',
      'getLearingExpectationSubject',
      'getScoreFromAttendance'
    ]),
    onAdvisorComment() {
      this.advisor_comment = true
    },
    findScoringInput() {
      let {
        sc_item_subject_comp_list,
        sc_subject_id,
        st_class_id,
        ...params
      } = this.model
      return this.findScoring(params)
    },
    async fetchData() {
      this.loading = true
      let structure = await this.getProgramStructure({ ...this.model }).catch(
        error => {
          this.$toasted.error(error.message)
        }
      )

      await this.$store.dispatch('gradingDefinition/fetch', {
          filter: {
            acp_id: this.model.acp_id,
            acps_id: this.model.acps_id
          },
          page: -1
        })
        .then(response => {
          this.gradingDefinitions = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })

      await this.getComponents(
        // get component base on what score assement main setup
        Object.assign({}, structure.data, { acps_id: this.acpsId })
      )
        .then(response => {
          this.scoreComponents = response.data
          this.electiveSubjects = response.electiveSubjects
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
      if(this.enableRating)
      {
        await this.getLearingExpectationSubject(
        // get elective subject base on grade setup
        { grade_id: this.gradeId, term_order: this.model.cycle_value }
        )
          .then(response => {
            this.learningExpectationSubjects = response.data
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
      await this.findScoreAssementDetail({ ...structure.data }) // find score assement detail by score asessment id and program structure id
        .then(response => {
          this.createInputData(response.data)
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
      this.fetchComment()
      await this.findScoringInput()
        .then(response => {
          if (!_.isEmpty(response.data) || response.data.length > 0) {
            this.dataInput.forEach(el => {
              if (response.data[el.sc_subject_id] !== undefined) {
                response.data[el.sc_subject_id].forEach(edit => {
                  el.sc_item_subject_comp_list
                    .filter(
                      item =>
                        item.sc_item_subject_comp_id ==
                        edit.sc_item_subject_comp_id
                    )
                    .forEach(subItem => {
                      subItem.actual_score = edit.actual_score
                      subItem.disable = edit.disable
                      subItem.max_score = edit.max_score
                      subItem.sc_item_subject_comp_id =
                        edit.sc_item_subject_comp_id
                      subItem.sc_subject_id = edit.sc_subject_id
                      subItem.scoring_id = edit.scoring_id
                    })
                    //set edit data unit title
                    this.unit_title = edit.unit_title
                })
              }
            })
          }
          if (
            !_.isEmpty(response.learningStrands) ||
            response.learningStrands.length > 0
          ) {
            this.learning_strands_sc_subject_id_list = response.learningStrands.map(el => ({
              scoring_id: el.scoring_id,
              subject_id: el.subject_id,
              core_subject_name_foreign: this.getParentSubjectName(el.subject_id),
              sc_subject_id: el.sc_subject_id,
              elective_subject_name_foreign: this.getElectiveSubjectName(el.sc_subject_id),
              grade: el.grade
            })) 
            this.unit_title = response.learningStrands[0].unit_title
          }
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getElectiveSubjectName (sc_subject_id) {
      return this.learningExpectationSubjects
        .filter(c => c.sc_subject_id == sc_subject_id)
        .reduce((init, item) => (init = item.elective_subject_name_foreign), null)
    },
    getParentSubjectName (subject_id) {
      return this.learningExpectationSubjects
      .filter(c => c.subject_id == subject_id)
        .reduce((init, item) => (init = item.core_subject_name_foreign), null)
    },
    createInputData(data) {
      let componentData = data
      if(this.enableRating)
      {
        // this.learning_strands_sc_subject_id_list =this.electiveSubjects.map(el => ({
        //     scoring_id: 0,
        //     sc_subject_id: el.subject_id,
        //     grade: null
        //   })) //enable learning strands rating in grade
        this.learning_strands_sc_subject_id_list = this.learningExpectationSubjects.map(el => ({
            scoring_id: 0,
            subject_id: el.subject_id,
            core_subject_name_foreign: el.core_subject_name_foreign,
            sc_subject_id: el.sc_subject_id,
            elective_subject_name_foreign: el.elective_subject_name_foreign,
            grade: null
          })) //enable learning strands rating in grade

      }
      if (this.isNotIgnoreByScoringCycle) {
        if(this.model.scoring_cycle_id == 5)//unit
        {
          componentData = data.filter(
              c => includes(this.scoreComponents.filter(el => el.is_elective_subject_parent == true).map(d => d.id), c.sc_subject_id)
            )
        }
        if(this.model.scoring_cycle_id == 2)//semester
        {
          componentData = data.filter(
              c => includes(this.scoreComponents.filter(el => el.is_elective_subject_parent == false).map(d => d.id), c.sc_subject_id)
            )
        }
        _.orderBy(componentData, ['subject_order'], ['asc']).forEach(el => {
          this.actual_score_for_main_component_display.push({
            sc_subject_id: el.sc_subject_id,
            actual_score:
              el.enable_semester == true && this.model.scoring_cycle_id == 2
                ? el.enable_sciense == true
                  ? el.actual_score_sciense_semester
                  : el.actual_score_semester
                : el.actual_score
          })
          this.dataInput.push(
            Object.assign({}, this.model, {
              sc_subject_id: el.sc_subject_id,
              sc_item_subject_comp_list: this.isNotIgnoreByScoringCycle
                ? this.createSub(el).sort((a, b) => {
                    return a.display_order - b.display_order
                  })
                : []
            })
          )
          
        })
      }
    },
    // create sub display comment score input
    createSub(item) {
      if (this.model.sc_bas_id == 2) {
        // subject base
        return [
          {
            scoring_id: 0,
            sc_item_subject_comp_id: item.sc_subject_id,
            actual_score: -1,
            max_score: this.getMaxScore(item),
            disable: true,
            display_order: 0
          }
        ]
      }
      if (this.model.sc_bas_id == 1) {
        // item base
        return item.component_detail_item_list.map(el => ({
          scoring_id: 0,
          sc_item_subject_comp_id: el.sc_item_subject_comp_id,
          actual_score: -1,
          max_score: this.getMaxScore(el),
          disable: true,
          display_order: this.getOrderDisplay(
            item.sc_subject_id,
            el.sc_item_subject_comp_id
          )
        }))
      }
    },
    getMaxScore(item) {
      /**
       * 0 ធម្មតា	Normal
       * 1	សិក្សាសង្គម	Society
       * 2	វិទ្យាសាស្ត្រ	Sciense
       */
      let findClass = this.classOperations.find(
        c => c.class_id == this.model.class_id
      )
      if (findClass.ac_category_id == 2 && item.enable_sciense) {
        if (item.enable_semester && this.model.scoring_cycle_id == 2) {
          return item.actual_score_sciense_semester
        }
        return item.actual_score_sciense
      }

      if (item.enable_semester) {
        return item.actual_score_semester
      }

      return item.actual_score
    },
    getComponentName(sc_subject_id) {
      return this.scoreComponents
        .filter(c => c.id == sc_subject_id)
        .reduce(
          (init, item) =>
            (init = {
              kh: item.name_native,
              en: item.name
            }),
          null
        )
    },
    getActualScoreMainComponent(sc_subject_id) {
      return this.actual_score_for_main_component_display
        .filter(a => a.sc_subject_id == sc_subject_id)
        .reduce((init, item) => (init = item.actual_score), null)
    },
    getSubcomponentName(sc_subject_id, sc_item_subject_comp_id) {
      if (this.model.sc_bas_id == 2) {
        return this.getComponentName(sc_subject_id).en
      }
      return this.scoreComponents
        .filter(c => c.id == sc_subject_id)
        .flatMap(el =>
          el.items.filter(item => item.id == sc_item_subject_comp_id)
        )
        .reduce((init, item) => (init = item.name), null)
    },
    getOrderDisplay(sc_subject_id, sc_item_subject_comp_id) {
      // if (this.model.scoring_cycle_id == 2) {
      //   return 0
      // }
      return this.scoreComponents
        .filter(c => c.id == sc_subject_id)
        .flatMap(el =>
          el.items.filter(item => item.id == sc_item_subject_comp_id)
        )
        .reduce((init, item) => (init = item.display_order), 0)
    },
    async onSave() {
      this.errors = new Errors()
      this.waiting = true
      this.successCreate = []
      this.show_alert = false
      for (const [index, item] of this.dataInput.entries()) {
        await this.store(
          Object.assign({}, item, {
            sc_stu_com_id: this.model.sc_stu_com_id,
            advisor_id: this.model.advisor_id,
            comments: this.model.comments,
            suggesstion: this.model.suggesstion,
            unit_title: this.unit_title,
            is_last_row: index === this.dataInput.length - 1
          })
        )
          .then(() => {
            this.successCreate.push(item)
          })
          .catch(error => {
            this.show_alert = true
            this.waiting = false
            this.$toasted.error(error.message)
            if (error.errors != undefined) {
              this.errors = new Errors(error.errors)
            }
          })
        if (this.show_alert) {
          break
        }
      }
      this.successCreate.forEach(async el => {
        await this.dataInput.splice(this.dataInput.indexOf(el), 1)
      })
      let { sc_item_subject_comp_list, ...excludeData } = this.model
      if (this.learning_strands_sc_subject_id_list.length > 0) {
        await this.store(
          Object.assign({}, excludeData, {
            learning_strands_sc_subject_id_list: this
              .learning_strands_sc_subject_id_list,
            sc_subject_id_list: [],
            score_type: 3,
            unit_title: this.unit_title
          })
        )
          .then(() => {
            this.waiting = false
            if (this.dataInput.length == 0) {
              this.$emit('closeModal')
              this.$toasted.success('Action completed successfully!')
            }
          })
          .catch(error => {
            this.errors = new Errors(error.errors)
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.waiting = false
          })
      } else {
        this.waiting = false
        if (this.dataInput.length == 0) {
          this.$emit('closeModal')
          this.model.sc_stu_com_id = 0
          this.model.advisor_id = null
          this.model.comments = null
          this.model.suggesstion = null
          this.model.unit_title = null
          this.$toasted.success('Action completed successfully!')
        }
      }
    },
    getIsHasComponentItems(sc_subject_id, sc_item_subject_comp_id) {
      return this.scoreComponents
        .filter(c => c.id == sc_subject_id)
        .flatMap(el =>
          el.items.filter(item => item.id == sc_item_subject_comp_id)
        )
        .reduce((init, item) => (init = item.has_component_items), false)
    },
    isElectiveSubjectParent(sc_subject_id) {
      return false
      // return this.scoreComponents
      //   .filter(c => c.id == sc_subject_id)
      //   .reduce((init, item) => (init = item.is_elective_subject_parent), null)
    },
    async getAvgScoreComponentItems(sub) {
      let result = await this.getAvgScore({
        params: {
          student_id: this.model.student_id,
          ac_term_id: this.model.ac_term_id,
          grade_id: this.gradeId,
          scoring_cycle_id: this.model.scoring_cycle_id,
          subject_comp_id: sub.sc_item_subject_comp_id,
          cycle_value: this.model.cycle_value
        }
      }).catch(() => {
        // this.$toasted.error(error.message)
      })
      sub.actual_score = result == -1 ? -1 : parseFloat(result).toFixed(2)
    },
    async getAvgScoreByParentSubject(sc_subject_id, sub) {
      let result = await this.getAvgScoreBySubject({
        params: {
          student_id: this.model.student_id,
          subject_id: sc_subject_id,
          ac_term_id: this.model.ac_term_id,
          grade_id: this.gradeId
        }
      }).catch(() => {
        // this.$toasted.error(error.message)
      })
      sub.actual_score =
        result.length > 0 ? parseFloat(result[0].max_score).toFixed(2) : 0
    },
    fetchComment() {
      this.loading = true
      this.model.sc_stu_com_id = 0
      this.model.advisor_id = null
      this.model.comments = null
      this.model.suggesstion = null
      this.$store
        .dispatch('studentScoringEntry/findComment', {
          params: {
            student_id: this.value.student_id,
            st_class_id: this.value.st_class_id,
            scoring_cycle_id: this.value.scoring_cycle_id,
            cycle_value: this.value.cycle_value
          }
        })
        .then(response => {
          if (response.data) {
            this.model.sc_stu_com_id = response.data.sc_stu_com_id
            this.model.advisor_id = response.data.advisor_id
            this.model.comments = response.data.comments
            this.model.suggesstion = response.data.suggesstion
          }
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    isAutoFromAttendance(sc_subject_id, sc_item_subject_comp_id) {
      return this.scoreComponents
        .filter(c => c.id == sc_subject_id)
        .flatMap(el =>
          el.items.filter(item => item.id == sc_item_subject_comp_id)
        )
        .reduce((init, item) => (init = item.is_auto_from_att), false)
    },
    async getScoreAutoFromAttendance(sc_subject_id, sub) {
      let result = await this.getScoreFromAttendance({
        params: {
          student_id: this.model.student_id,
          class_id: this.model.class_id,
          subject_id: sc_subject_id
        }
      })
      sub.actual_score = result.actual_score > 0 ? result.actual_score : 0
    }
  }
}
</script>

<style lang="css" scoped>
table {
  width: 100%;
}
table > thead {
  border-bottom: 1px solid #d8d8d8;
  padding: 3px;
}
table > thead > tr > th {
  padding: 4px 7px;
}
table > tbody > tr > td {
  padding: 4px 7px;
}
.bb {
  border-bottom: 1px solid #d8d8d8;
  outline: none;
}
.cover {
  opacity: 0.2;
}
#cover-image img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}
.text-uppercase {
  text-transform: uppercase !important;
}
#img-frame {
  display: block;
  position: relative;
  margin: -51%;
}
#img-frame img {
  object-fit: contain;
  width: 15%;
  height: 15%;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 3px;
  margin: 0 auto;
}
table td {
  vertical-align: middle;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
fieldset {
  border: none;
  padding: 0 !important;
}
</style>
